// Update card product page tiles on variant change
function updateCardType(event, type) {
  const cardTypeElements = document.querySelectorAll(".card-type");
  const cardTypeItemElements = document.querySelectorAll(".card-type-item");
  cardTypeElements.forEach((element) => {
    element.classList.remove("standard", "metal");
    element.classList.add(type);
  });
  cardTypeItemElements.forEach((element) => {
    element.classList.remove("standard", "metal");
    element.classList.add(type);
  });
}